import React from "react";
import Navbar from "../components/Navbar";
import Whatsapp from "../components/Whatsapp";
// import bgImage from "../assets/images/project.jpg";
import banner1 from "../assets/images/projects.jpg";
import plotImg from "../assets/images/plot.png"; 
import houseImg from "../assets/images/house.jpg";
import villaImg from "../assets/images/villa.png";
import apartmentImg from "../assets/images/apartment.png";
import "../assets/css/style.css"; 
import Footer from "../components/Footer";

const Projects = () => {
  return (
    <div>
      <Navbar />
      <div className="project-banner" style={{ backgroundImage: `url(${banner1})`, marginTop: "88px" }}></div>

      {/* Our Projects Heading */}
      <div className="projects-section">
        <h2 className="projects-title">Our Projects</h2>
        <div class="centered-text">
          <p>Experience a harmonious and prosperous lifestyle with our Villas, Plots, Apartments, and Houses. 
            Enjoy modern amenities, prime locations, and secure communities, offering the perfect blend of comfort, 
            convenience, and long term value for your dream home or investment.
          </p>
        </div>

        <div className="project-item left">
          <img src={plotImg} alt="Plots" className="project-image" />
          <div className="project-content">
            <h1 className="projects-title">PLOTS</h1>
            <p>Own a premium plot in a strategically located and well planned community, offering the perfect foundation 
              for your dream home or a smart investment. With clear titles, legally verified documentation, and modern 
              infrastructure, our plots ensure a seamless and secure buying experience. Enjoy the freedom to design your 
              space while benefiting from a peaceful yet well connected environment.
              </p>
              <p>
              Situated in high growth areas, our plots provide easy access to schools, hospitals, shopping centers, and 
              major highways. With developed roads, drainage systems, and essential utilities, these plots offer both 
              convenience and long-term value. Whether you're looking to build your perfect home or secure a high return 
              investment, our plots are the ideal choice for a bright future.
              </p>
          </div>
        </div>

        <div className="project-item right">
        <img src={houseImg} alt="Houses" className="project-image" />
          <div className="project-content">
            <h1 className="projects-title">Houses</h1>
            <p>Our houses offer modern amenities, privacy, and a comfortable living environment, perfect for families
               and individuals alike. With secure neighborhoods and excellent connectivity, these homes provide easy 
               access to essential facilities, ensuring a convenient and fulfilling lifestyle.
              </p>
              <p>
              Located in well connected neighborhoods, our apartments provide easy access to schools, hospitals, 
              shopping centers, and transport hubs. Enjoy the benefits of 24/7 security, recreational spaces, and 
              premium facilities, ensuring a safe and fulfilling living experience. Whether you're looking for a stylish 
              new home or a valuable investment, our apartments offer the perfect balance of comfort, convenience, and 
              growth potential.
              </p>
          </div>
        </div>

        <div className="project-item left">
          <img src={villaImg} alt="Villas" className="project-image" />
          <div className="project-content">
            <h1 className="projects-title">Villas</h1>
            <p> Our villas offer modern architecture, premium amenities, and private outdoor spaces, ensuring a serene 
              and comfortable lifestyle. With elegant interiors, ample natural light, and thoughtfully planned layouts, 
              these homes provide the perfect retreat for families and individuals seeking exclusivity and comfort.
              </p>
              <p>
              Nestled in secure and well connected communities, our villas offer easy access to schools, hospitals, shopping 
              centers, and major roadways. Enjoy the perks of private gardens, dedicated parking, and world class 
              facilities, creating a perfect blend of privacy and convenience. Whether you're looking for a dream home or
               a high value investment, our villas promise luxury, security, and long term growth potential.
              </p>
          </div>
        </div>

        <div className="project-item right">
        <img src={apartmentImg} alt="Apartments" className="project-image" />
          <div className="project-content">
            <h1 className="projects-title">Apartments</h1>
            <p>Experience the perfect blend of comfort and convenience with our modern apartments in prime locations. 
              Designed for contemporary living, our apartments feature smart layouts, stylish interiors, and top notch 
              amenities, making them ideal for families and professionals alike. Enjoy a hassle free lifestyle with 
              secure surroundings, ample natural light, and well planned living spaces that cater to all your needs.
            </p>
            <p>
            Located in vibrant, well connected neighborhoods, our apartments offer easy access to schools, hospitals, 
            shopping centers, and transport hubs. With 24/7 security, recreational spaces, fitness centers, and more, 
            you can enjoy a safe and fulfilling urban lifestyle. Whether you're looking for a cozy home or a smart 
            investment, our apartments provide exceptional value and long term growth potential.
            </p>
          </div>
        </div>
      </div>
      <Whatsapp />
      <Footer/>
    </div>
  );
};
export default Projects;
